import { Component, React, createRef } from "react";
import { ValidateEmail, normalize } from "../../../config/utility";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  addNewSupplier,
  getAddAgentEmailPreview,
  getSuppliesBusinessTypes,
} from "./../../../config/general_api_calls";
import { getCustomSettings } from "./../../../config/reseller_api_calls";
import $ from "jquery";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import HelperClass from "./../../../config/helperClass";
import MutextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import { PhoneInput } from "react-international-phone";
import Select from "react-select";
import countryList from "react-select-country-list";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { PhoneNumberUtil } from "google-libphonenumber";
import PasswordStrengthBar from "react-password-strength-bar";
import localization from "../../../localization/enUS";

import Autocomplete from "@material-ui/lab/Autocomplete";
import ReactPhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/material.css";

const auth = new HelperClass();

class Addagent extends Component {
  constructor() {
    super();
    this.state = {
      serviceData: [],
      select_service: "",
      errorMessage: "",
      serviceId: "",
      title: "",
      name: "",
      logo: "",
      supplier_email: "",
      supplier_phone: "",
      supplier_company: "",
      supplier_password: "",
      c_password: "",
      supplier_address: "",
      supplier_address2: "",
      supplier_city: "",
      supplier_state: "",
      supplier_zip: "",
      supplier_country: "United States",
      description: "",
      successMessage: "",
      tableLoader: true,
      domain: "",
      step: 1,
      a_ip: "",
      is_verified: 0,
      passwordShown: false,
      confirmPasswordShown: false,
      errorName: "",
      errorSupplierStatus: "",
      errorBusinessType: "",
      errorSupplierCompany: "",
      errorSupplierEmail: "",
      errorSupplierPhone: "",
      errorSupplierAddress: "",
      errorSupplierCity: "",
      errorSupplierState: "",
      errorSupplierZip: "",
      errorSupplierCountry: "",
      errorSupplierPassword: "",
      errorCPassword: "",
      useGooglePlaces: true,
      toggleButtonText: "Allow PO Box Address",
      notifyCheckBox: false,
      account_status: "",
      business_type: "",
      passwordRequired: false,
      address_autocomplete: true,
      address_validation: true,
      supplier_business_types: [],
    };
    this.countryOptions = countryList()
      .getData()
      .filter(
        (country) => country.label !== "United States Minor Outlying Islands"
      )
      .sort((a, b) => {
        if (a.label === "United States") return -1;
        if (b.label === "United States") return 1;
        return a.label.localeCompare(b.label);
      });
    this.phoneInputRef = createRef();
  }

  serviceSigning = async (value, tableMeta) => {
    //console.log("tableMeta.rowData: ", tableMeta.rowData[6]);
  };

  async componentDidMount() {
    this.getCustomSettings();
    this.getSuppliesBusinessTypes();
  }

  handleToggle = () => {
    this.setState((prevState) => ({
      useGooglePlaces: !prevState.useGooglePlaces,
      toggleButtonText:
        prevState.toggleButtonText === "Allow PO Box Address"
          ? "Allow Simple Address"
          : "Allow PO Box Address",
    }));
  };

  handleFocus = () => {
    // Move cursor to the end of the input value
    const input = this.phoneInputRef.current;
    if (input) {
      const value = input.value;
      input.setSelectionRange(value.length, value.length);
    }
  };

  phoneUtil = PhoneNumberUtil.getInstance();

  isPhoneValid = (phone) => {
    try {
      return this.phoneUtil.isValidNumber(
        this.phoneUtil.parseAndKeepRawInput(phone)
      );
    } catch (error) {
      return false;
    }
  };

  togglePassword = () => {
    this.setState({
      passwordShown: !this.state.passwordShown,
    });
  };

  toggleConfirmPassword = () => {
    this.setState({
      confirmPasswordShown: !this.state.confirmPasswordShown,
    });
  };

  handleAddressSelect = async (place) => {
    const { description } = place.value;
    try {
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(
          description
        )}&key=${process.env.REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY}`
      );
      const data = await response.json();

      if (data.status === "OK") {
        const addressComponents = data.results[0].address_components;
        const formattedAddress = data.results[0].formatted_address;
        let city = null;
        let state = null;
        let country = null;
        let zipCode = null;
        let streetAddress = "";
        let neighborhood = null;
        let locality = null;
        let address2 = "";
        addressComponents.forEach((component) => {
          if (component.types.includes("neighborhood")) {
            neighborhood = component.long_name;
          } else if (component.types.includes("locality")) {
            locality = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.short_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          } else if (component.types.includes("postal_code")) {
            zipCode = component.long_name;
          } else if (component.types.includes("subpremise")) {
            address2 = component.long_name;
          } else if (
            ![
              "neighborhood",
              "sublocality",
              "sublocality_level_1",
              "sublocality_level_2",
              "administrative_area_level_2",
              "administrative_area_level_3",
              "postal_code_suffix",
            ].includes(component.types[0])
          ) {
            if (streetAddress !== "") {
              streetAddress += " ";
            }
            streetAddress += component.long_name;
          }
        });
        // Check if neighborhood is part of the formatted address
        if (neighborhood && formattedAddress.includes(neighborhood)) {
          city = neighborhood;
        } else {
          city = locality;
        }
        this.setState({
          supplier_city: city && city !== "" ? city : "",
          supplier_state: state && state !== "" ? state : "",
          supplier_zip: zipCode && zipCode !== "" ? zipCode : "",
          supplier_country: country && country !== "" ? country : "",
          supplier_address:
            streetAddress && streetAddress !== "" ? streetAddress : "",
          supplier_address2: address2 && address2 !== "" ? address2 : "",
        });
      } else {
        console.error("Reverse geocoding request failed:", data.status);
      }
    } catch (error) {
      console.error("Error fetching reverse geocoding data:", error);
    }
  };

  handleChangeCountry = (event) => {
    //console.log("event.label: ", event.label);
    const country = event.label;
    this.setState({
      supplier_country: country,
    });
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  handleChange = (event) => {
    const { target } = event;
    let value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;
    if (name === "name") {
      value = value.replace(/[^a-zA-Z\s'.,\-:()|!@]/g, "");
    } else if (name === "supplier_company") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    } else if (name === "title") {
      value = value.replace(/[^a-zA-Z0-9\s_\-.,&:()|!@]/g, "");
    }

    this.setState({
      [name]: value,
    });
  };

  handleChangeStep = (input) => (e) => {
    this.setState({ [input]: e.target.value });
  };

  handleChangeFile = async (event) => {
    this.setState({
      rate_deck_file: event.target.files[0],
    });
    //await this.sendFileData(event.target.files[0]);
  };

  modalHide = () => {
    window.$("#modalAlert").modal("hide");
    // this.props.agreementSigned();
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  nextStep = () => {
    const { step } = this.state;

    this.setState({
      step: step + 1,
    });
    //console.log("STEP: ", this.state.step);
  };

  // Go to prev step
  prevStep = () => {
    const { step } = this.state;
    this.setState({
      step: step - 1,
    });
  };
  firstStep = () => {
    this.setState({
      step: 1,
    });
  };

  formAgentUpdate = async () => {
    let {
      title,
      name,
      supplier_email,
      supplier_password,
      c_password,
      supplier_phone,
      supplier_company,
      supplier_address,
      supplier_address2,
      supplier_city,
      supplier_state,
      supplier_zip,
      supplier_country,
      account_status,
      business_type,
    } = this.state;
    this.setState({
      successMessage: "",
      errorMessage: "",
      errorSelectAgent: "",
      errorName: "",
      errorStatus: "",
      errorSupplierCompany: "",
      errorSupplierEmail: "",
      errorSupplierPhone: "",
      errorSupplierAddress: "",
      errorSupplierCity: "",
      errorSupplierState: "",
      errorSupplierZip: "",
      errorSupplierCountry: "",
      errorSupplierPassword: "",
      errorCPassword: "",
      errorPass: "",
      errorSupplierStatus: "",
      errorBusinessType: "",
    });
    let is_validated = true;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
    if (this.state.name === "") {
      this.setState({
        errorName: "error",
        errorMessage: `${localization.suppliersListing.text} Name is required.`,
      });
      is_validated = false;
    } else if (this.state.supplier_company === "") {
      this.setState({
        errorName: "",
        errorSupplierCompany: "error",
        errorMessage: "Company name is required.",
      });
      is_validated = false;
    } else if (this.state.supplier_email === "") {
      this.setState({
        errorSupplierCompany: "",
        errorSupplierEmail: "error",
        errorMessage: "Email address is required.",
      });
      is_validated = false;
    } else if (ValidateEmail(this.state.supplier_email) === false) {
      this.setState({
        errorSupplierCompany: "",
        errorSupplierEmail: "error",
        errorMessage: "Invalid email format.",
      });
      is_validated = false;
    } else if (this.state.supplier_phone === "") {
      this.setState({
        errorSupplierEmail: "",
        errorSupplierPhone: "error",
        errorMessage: "Phone is required.",
      });
      is_validated = false;
    } else if (!this.isPhoneValid(supplier_phone)) {
      this.setState({
        errorSupplierEmail: "",
        errorSupplierPhone: "error",
        errorMessage: "Invalid phone number.",
      });
      return false;
    } else if (this.state.supplier_address === "") {
      this.setState({
        errorSupplierPhone: "",
        errorSupplierAddress: "error",
        errorMessage: "Address is required.",
      });
      is_validated = false;
    } else if (this.state.supplier_city === "") {
      this.setState({
        errorSupplierAddress: "",
        errorSupplierCity: "error",
        errorMessage: "City is required.",
      });
      is_validated = false;
    } else if (this.state.supplier_state === "") {
      this.setState({
        errorSupplierCity: "",
        errorSupplierState: "error",
        errorMessage: "State is required.",
      });
      is_validated = false;
    } else if (this.state.supplier_zip === "") {
      this.setState({
        errorSupplierState: "",
        errorSupplierZip: "error",
        errorMessage: "Zip/postal code is required.",
      });
      is_validated = false;
    } else if (this.state.supplier_country === "") {
      this.setState({
        errorSupplierZip: "",
        errorSupplierCountry: "error",
        errorMessage: "Country is required.",
      });
      is_validated = false;
    } else if (this.state.business_type === "") {
      this.setState({
        errorName: "",
        errorBusinessType: "error",
        errorMessage: "Business Type is required.",
      });
      is_validated = false;
    } else if (this.state.account_status === "") {
      this.setState({
        errorName: "",
        errorSupplierStatus: "error",
        errorMessage: "Account Status is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.supplier_password === ""
    ) {
      this.setState({
        errorSupplierCountry: "",
        errorSupplierPassword: "error",
        errorMessage: "Password is required.",
      });
      is_validated = false;
    } else if (
      this.state.passwordRequired &&
      this.state.supplier_password !== ""
    ) {
      if (this.state.supplier_password.length < 8) {
        this.setState({
          errorSupplierCountry: "",
          errorSupplierPassword: "error",
          errorMessage: "Use 8 characters or more for your password",
        });
        is_validated = false;
      } else if (
        this.state.passwordRequired &&
        !passwordRegex.test(supplier_password)
      ) {
        this.setState({
          errorSupplierCountry: "",
          errorSupplierPassword: "error",
          errorMessage:
            "Password must be at least 8 characters, with uppercase, lowercase, number & special character.",
        });
        is_validated = false;
      } else if (this.state.c_password === "") {
        this.setState({
          errorSupplierPassword: "",
          errorCPassword: "error",
          errorMessage: "Confirm password is required.",
        });
        is_validated = false;
      } else if (this.state.c_password.length < 8) {
        this.setState({
          errorSupplierPassword: "",
          errorCPassword: "error",
          errorMessage: "Use 8 characters or more for your confirm password",
        });
        is_validated = false;
      } else if (
        this.state.supplier_password.trim() != this.state.c_password.trim()
      ) {
        this.setState({
          errorSupplierPassword: "",
          errorCPassword: "error",
          errorMessage: "Password and confirm password does not match.",
        });
        is_validated = false;
      }
    }
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (is_validated) {
      let apiResponce = await addNewSupplier(
        auth.getAccount(),
        auth.getToken(),
        title,
        name,
        supplier_email,
        supplier_password,
        supplier_phone,
        supplier_company,
        supplier_address,
        supplier_address2,
        supplier_city,
        supplier_state,
        supplier_zip,
        supplier_country,
        this.state.notifyCheckBox.toString(),
        account_status,
        business_type,
        this.state.passwordRequired.toString(),
        auth.getEmail(),
        auth.getName()
      );
      //console.log("Add Supplier Response: ", apiResponce.data);
      if (
        apiResponce.data.status === 403 ||
        apiResponce.data.errors === "authentication missing" ||
        apiResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        apiResponce.data.status === 409 &&
        apiResponce.data.message === "Address validation failed"
      ) {
        const formattedErrorMessage = apiResponce.data.errors
          ? String(apiResponce.data.errors).replace(/,/g, "<br />")
          : "Address validation failed";

        this.setState({
          errorMessage: formattedErrorMessage,
          tableLoader: false,
        });
      } else if (
        apiResponce.data.status === 200 &&
        apiResponce.data.message === "success"
      ) {
        this.setState({
          successMessage: `${localization.suppliersListing.text} added successfully.`,
          tableLoader: false,
        });
        setTimeout(async function () {
          window.location.replace("/suppliers");
        }, 3000);
      } else if (
        apiResponce.data.status === 405 &&
        apiResponce.data.message === "email_exists"
      ) {
        this.setState({
          errorMessage:
            "Email already exists. Please try different email address.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else if (
        apiResponce.data.status === 404 &&
        apiResponce.data.message === "fail"
      ) {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        return false;
      } else {
        this.setState({
          errorMessage: "Something went wrong,try again later.",
          disabled: false,
          tableLoader: false,
        });
        //auth.logout();
      }
    }
  };

  onFileChange = (event) => {
    // Update the state
    this.setState({ logo: event.target.files[0] });
  };

  preViewDefault = async () => {
    const getEmailResponse = await getAddAgentEmailPreview(
      auth.getAccount(),
      auth.getToken()
    );
    //console.log("getEmailResponse: ", getEmailResponse.data);
    if (
      getEmailResponse.data.status === 403 ||
      getEmailResponse.data.errors === "authentication missing" ||
      getEmailResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (getEmailResponse.data.status === 404) {
      //window.location.replace("/error");
    } else if (
      getEmailResponse.data.status === 200 &&
      getEmailResponse.data.message === "success"
    ) {
      let emailTemplate = getEmailResponse.data.data[0][3];
      let logoUrl = getEmailResponse.data.data[0]["reseller_logo"];

      if (emailTemplate && emailTemplate !== "") {
        // Replace company logo
        emailTemplate = emailTemplate.replace(/{{comp_logo}}/g, logoUrl);

        // Replace placeholders with user input values
        emailTemplate = emailTemplate.replace(
          /{{client_name}}/g,
          this.state.name || "{{client_name}}"
        );
        emailTemplate = emailTemplate.replace(
          /{{comp_name}}/g,
          auth.getCompName() || "{{comp_name}}"
        );
        emailTemplate = emailTemplate.replace(
          /{{client_email}}/g,
          this.state.supplier_email || "{{client_email}}"
        );

        // Clean up any empty paragraphs
        emailTemplate = emailTemplate.replace(/<p>&nbsp;<\/p>/g, "");
      }

      this.setState({
        email_id: getEmailResponse.data.data[0][0],
        email_title: getEmailResponse.data.data[0][1],
        email_subject: getEmailResponse.data.data[0][2],
        email_template: emailTemplate,
        tableLoader: false,
        isEditorReady: true,
      });
      window.$("#modalPreviewDefaultModal").modal("show");
    } else {
      //window.location.replace("/error");
    }
  };

  closePreviewModal = () => {
    // Close the preview modal
    window.$("#modalPreviewDefaultModal").modal("hide");
  };

  getCustomSettings = async () => {
    try {
      const getCustomSetting_res = await getCustomSettings(
        auth.getAccount(),
        auth.getToken()
      );
      //console.log("getCustomSetting_res: ", getCustomSetting_res.data);
      if (
        getCustomSetting_res.data.status === 200 &&
        getCustomSetting_res.data.data &&
        getCustomSetting_res.data.data.length > 0
      ) {
        this.setState({
          address_autocomplete:
            getCustomSetting_res.data.data[0].address_autocomplete || "Yes",
          address_validation:
            getCustomSetting_res.data.data[0].address_validation || "Yes",
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  getSuppliesBusinessTypes = async () => {
    try {
      const SuppliesBusinessTypes_res = await getSuppliesBusinessTypes(
        auth.getAccount(),
        auth.getToken()
      );
      //console.log("SuppliesBusinessTypes_res: ", SuppliesBusinessTypes_res.data);
      if (
        SuppliesBusinessTypes_res.data.status === 200 &&
        SuppliesBusinessTypes_res.data.data &&
        SuppliesBusinessTypes_res.data.data.length > 0
      ) {
        this.setState({
          supplier_business_types: SuppliesBusinessTypes_res.data.data,
        });
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  render() {
    const { useGooglePlaces, toggleButtonText } = this.state;
    const errorStyle = this.state.errorSupplierAddress
      ? {
          input: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
          control: (provided) => ({
            ...provided,
            borderColor: "red",
          }),
        }
      : {};
    return (
      <div className="nk-content " id="">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" ? <SettingsError /> : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" ? <MsaWarning /> : null}

          {/* MSA WARNING END */}
          <div className="nk-block-head nk-block-head-sm">
            <div className="nk-block-between">
              <div className="nk-block-head-content">
                <Breadcrumbs aria-label="breadcrumb">
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    <HomeIcon fontSize="inherit" className="" />
                    Home
                  </Link>
                  <Link
                    color="inherit"
                    onClick={() => this.addMenuHistory("/suppliers")}
                    className=""
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                  >
                    {localization.suppliersListing.heading}
                  </Link>
                  <Typography color="textPrimary" className="">
                    Add New {localization.suppliersListing.text}
                  </Typography>
                </Breadcrumbs>
              </div>
            </div>
          </div>
          <div className="row g-4">
            <div className="col-md-12">
              <div className="card card-bordered">
                <div className="card-inner">
                  <div className="card-head">
                    <h6 className="card-title">
                      Create {localization.suppliersListing.text} Account
                    </h6>
                  </div>
                  {this.state.errorMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-danger">
                        <div className="alert-text">
                          <h4>Error</h4>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.errorMessage,
                            }}
                          ></p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {this.state.successMessage !== "" ? (
                    <div className="example-alert">
                      <div className="alert alert-pro alert-success">
                        <div className="alert-text">
                          <h4>Success</h4>
                          <p>{this.state.successMessage}</p>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  <br />
                  <form
                    method="post"
                    encType="multipart/form-data"
                    autoComplete="off" role="presentation"
                  >
                    <div className="row g-4">
                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="name"
                          name="name"
                          type="text"
                          label="Full Name"
                          inputProps={{ maxLength: 50 }}
                          value={this.state.name}
                          onChange={this.handleChange}
                          helperText="Enter the name. Allowed characters: (&nbsp; ' &nbsp; - &nbsp; . &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorName === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          id="title"
                          name="title"
                          type="text"
                          inputProps={{ maxLength: 30 }}
                          label="Title"
                          value={this.state.title}
                          onChange={this.handleChange}
                          helperText="Enter the title. Allowed characters: (&nbsp; _ &nbsp; - &nbsp; . &nbsp; &amp; &nbsp; , &nbsp; : &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="supplier_company"
                          name="supplier_company"
                          type="text"
                          inputProps={{ maxLength: 100 }}
                          label="Company Name"
                          value={this.state.supplier_company}
                          onChange={this.handleChange}
                          helperText="Enter the company name. Allowed characters: (&nbsp; _ &nbsp; . &nbsp; - &nbsp; , &nbsp; : &nbsp; &amp; &nbsp; ( ) &nbsp; | &nbsp; ! &nbsp; @ )"
                          variant="outlined"
                          fullWidth
                          error={this.state.errorSupplierCompany === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          required
                          id="supplier_email"
                          name="supplier_email"
                          type="email"
                          label="Email Address"
                          defaultValue={this.state.supplier_email}
                          onChange={this.handleChange}
                          helperText="Enter your email address here."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorSupplierEmail === "error"}
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-6 agent_phone_cont">
                        <ReactPhoneInput
                          country={"us"}
                          value={this.state.supplier_phone}
                          onChange={(value) =>
                            this.handleChange({
                              target: { name: "supplier_phone", value },
                            })
                          }
                          inputProps={{
                            name: "supplier_phone",
                            id: "supplier_phone",
                            required: true,
                            maxLength: 20,
                          }}
                          inputStyle={
                            this.state.errorSupplierPhone
                              ? { borderColor: "red", width: "100%", height: "56px" }
                              : { width: "100%", height: "56px" }
                          }
                          containerStyle={{ width: "100%" }}
                          specialLabel="Phone Number"
                          placeholder="Enter the phone number here."
                          ref={this.phoneInputRef}
                          onFocus={this.handleFocus}
                        />
                      </div>

                      <div className="form-group col-md-6">
                        <div
                          className="nk-block-between-md"
                          style={{
                            position: "absolute",
                            zIndex: 9999,
                            right: "13px",
                            top: "-15px",
                          }}
                        >
                          <div className="nk-block-head-content">
                            <label
                              htmlFor="googleLocation-autocomplete"
                              style={{
                                color: "black",
                                fontWeight: "500",
                                marginBottom: "8px",
                              }}
                            >
                              {" "}
                            </label>
                          </div>
                          {this.state.address_autocomplete === "Yes" && (
                            <div className="nk-block-head-content">
                              <ul className="nk-block-tools gx-3">
                                <li>
                                  <a
                                    onClick={this.handleToggle}
                                    className="text-primary fs-11"
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "11px",
                                    }}
                                  >
                                    {toggleButtonText}
                                  </a>
                                </li>
                              </ul>
                            </div>
                          )}
                        </div>
                        {this.state.address_autocomplete === "Yes" ? (
                          useGooglePlaces ? (
                            <GooglePlacesAutocomplete
                              apiKey={
                                process.env
                                  .REACT_APP_ADDRESS_AUTOCOMPLETE_API_KEY
                              }
                              apiOptions={{ loading: 'async' }}
                              selectProps={{
                                value: this.state.supplier_address
                                  ? {
                                      label: this.state.supplier_address,
                                      value: this.state.supplier_address,
                                    }
                                  : null,
                                onChange: this.handleAddressSelect,
                                placeholder: this.state.supplier_address
                                  ? null
                                  : "Enter your address..",
                                styles: {
                                  ...errorStyle,
                                  input: (provided) => ({
                                    ...provided,
                                    color: "black",
                                    height: "47px",
                                  }),
                                  option: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  singleValue: (provided) => ({
                                    ...provided,
                                    color: "black",
                                  }),
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9,
                                  }),
                                },
                              }}
                              className="googleLocation-autocomplete"
                            />
                          ) : (
                            <MutextField
                              id="supplier_address"
                              name="supplier_address"
                              type="text"
                              label="PO Box Address. i.e, PO Box Number, City, State Zip Code"
                              value={this.state.supplier_address}
                              onChange={this.handleChange}
                              inputProps={{ maxLength: 100 }}
                              helperText=""
                              variant="outlined"
                              fullWidth
                            autoComplete="new-password"
                            />
                          )
                        ) : (
                          // address_autocomplete === "No" → show PO Box only
                          <MutextField
                            id="supplier_address"
                            name="supplier_address"
                            type="text"
                            label="Address"
                            value={this.state.supplier_address}
                            onChange={this.handleChange}
                            helperText=""
                            variant="outlined"
                            fullWidth
                          autoComplete="new-password"
                          />
                        )}
                      </div>

                      <div className="form-group col-md-6">
                        <MutextField
                          id="supplier_address2"
                          name="supplier_address2"
                          type="text"
                          label="Address 2"
                          value={this.state.supplier_address2}
                          onChange={this.handleChange}
                          inputProps={{ maxLength: 100 }}
                          helperText="If needed, enter additional address details, such as apartment number, suite, or unit."
                          variant="outlined"
                          fullWidth
                        autoComplete="new-password"
                        />
                      </div>

                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="supplier_city"
                          name="supplier_city"
                          type="text"
                          label="City"
                          value={this.state.supplier_city}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorSupplierCity === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div className="form-group col-md-3">
                        <MutextField
                          required
                          id="supplier_state"
                          name="supplier_state"
                          type="text"
                          label="State"
                          value={this.state.supplier_state}
                          inputProps={{ maxLength: 32 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorSupplierState === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-6"
                        style={{ marginBottom: "0px" }}
                      >
                        <MutextField
                          required
                          id="supplier_zip"
                          name="supplier_zip"
                          type="text"
                          label="Zip / Postal Code"
                          value={this.state.supplier_zip}
                          inputProps={{ maxLength: 9 }}
                          onChange={this.handleChange}
                          helperText=""
                          variant="outlined"
                          fullWidth
                          error={this.state.errorSupplierZip === "error"}
                        autoComplete="new-password"
                        />
                      </div>
                      <div
                        className="form-group col-md-6"
                        style={{ marginBottom: "0px" }}
                      >
                        <Autocomplete
                          id="supplier_country"
                          options={this.countryOptions}
                          getOptionLabel={(option) => option.label}
                          value={
                            this.state.supplier_country
                              ? this.countryOptions.find(
                                  (opt) => opt.label === this.state.supplier_country
                                ) || null
                              : null
                          }
                          onChange={(event, newValue) =>
                            this.handleChangeCountry(newValue)
                          }
                          renderInput={(params) => (
                            <MutextField
                              {...params}
                              label="Country"
                              variant="outlined"
                              placeholder="Select Country"
                              fullWidth
                              helperText="Select Country"
                            autoComplete="new-password"
                            />
                          )}
                          sx={{
                            "& .MuiOutlinedInput-root": {
                              minHeight: "56px",
                            },
                          }}
                        />
                      </div>
                      <div className="form-group col-md-6">
                        <MutextField
                          id="business_type"
                          name="business_type"
                          select
                          label="Select Business Type *"
                          value={this.state.business_type}
                          onChange={this.handleChange}
                          SelectProps={{
                            native: true,
                          }}
                          helperText="Select the supplier's business type."
                          variant="outlined"
                          fullWidth
                          error={this.state.errorBusinessType === "error"}
                        autoComplete="new-password"
                        >
                          <option key="" value=""></option>
                          {this.state.supplier_business_types.map((type) => (
                            <option key={type[0]} value={type[1]}>
                              {type[1]}
                            </option>
                          ))}
                        </MutextField>
                      </div>

                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{
                          padding: 0,
                          marginLeft: "3rem",
                          marginBottom: "1rem",
                        }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck3"
                            checked={this.state.passwordRequired}
                            onChange={() => {
                              const isChecked = !this.state.passwordRequired;
                              this.setState({
                                passwordRequired: isChecked,
                              });
                              //console.log("Required Password:", isChecked);
                            }}
                          />
                          <label
                            className="custom-control-label"
                            for="customCheck3"
                          >
                            Add Password
                          </label>
                        </div>
                      </div>
                      {this.state.passwordRequired && (
                        <>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="supplier_password"
                              name="supplier_password"
                              type={
                                this.state.passwordShown ? "text" : "password"
                              }
                              label="Password"
                              defaultValue={this.state.supplier_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={
                                this.state.errorSupplierPassword === "error"
                              }
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.togglePassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.passwordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Password must be at least 8 characters, with
                              uppercase, lowercase, number & special character.
                            </small>
                            <div style={{ marginTop: "30px" }}>
                              <PasswordStrengthBar
                                password={this.state.supplier_password}
                              />
                            </div>
                          </div>
                          <div
                            className="form-group col-md-6"
                            style={{ position: "relative" }}
                          >
                            <MutextField
                              required
                              id="c_password"
                              name="c_password"
                              type={
                                this.state.confirmPasswordShown
                                  ? "text"
                                  : "password"
                              }
                              label="Confirm Password"
                              defaultValue={this.state.c_password}
                              inputProps={{ maxLength: 50 }}
                              onChange={this.handleChange}
                              helperText=""
                              variant="outlined"
                              fullWidth
                              error={this.state.errorCPassword === "error"}
                            autoComplete="new-password"
                            />
                            <a
                              style={{
                                left: "auto",
                                right: "10px",
                                top: "41px",
                                position: "absolute",
                                cursor: "pointer",
                              }}
                              tabIndex="-1"
                              onClick={this.toggleConfirmPassword}
                              className="form-icon form-icon-right passcode-switch"
                              data-target="password"
                            >
                              {this.state.confirmPasswordShown ? (
                                <em className="icon ni ni-eye-off"></em>
                              ) : (
                                <em className="icon ni ni-eye"></em>
                              )}
                            </a>
                            <small
                              className="form-text"
                              style={{
                                position: "absolute",
                                top: "69px",
                                left: "26px",
                                color: "#0000008a",
                                fontSize: "0.75rem",
                                fontWeight: "400",
                                fontFamily:
                                  '"Roboto", "Helvetica", "Arial", sans-serif',
                              }}
                            >
                              Confirm Password must be at least 8 characters,
                              with uppercase, lowercase, number & special
                              character. Confirm Password must match the
                              Password.
                            </small>
                          </div>
                        </>
                      )}

                      <div
                        className="custom-control custom-control-lg custom-checkbox col-lg-12"
                        style={{ padding: 0, marginLeft: "3rem" }}
                      >
                        <div className="form-group">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck2"
                            checked={this.state.notifyCheckBox}
                            onChange={() => {
                              const isChecked = !this.state.notifyCheckBox;
                              this.setState({ notifyCheckBox: isChecked });
                              // console.log(
                              //   "Notify Checkbox Checked:",
                              //   isChecked
                              // );
                            }}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="customCheck2"
                          >
                            Notify {localization.suppliersListing.text}
                          </label>
                        </div>
                      </div>
                      <div
                        className="col-lg-12 no-padding-preview"
                        style={{
                          padding: 0,
                          cursor: "pointer",
                          color: "#0066cc",
                        }}
                        onClick={(e) => {
                          e.preventDefault();
                          this.preViewDefault();
                        }}
                      >
                        <span>Preview Notification Email </span>
                      </div>
                      <div style={{ clear: "both" }}></div>
                      <hr />
                      <div className="form-group text-right col-md-12">
                        <button
                          className="btn btn-lg btn-primary"
                          type="button"
                          disabled={this.state.disabled}
                          onClick={this.formAgentUpdate}
                        >
                          Submit
                        </button>
                      </div>
                    </div>
                  </form>

                  <br />
                  <br />
                  {/* PREVIEW DEFAULT MODAL  */}
                  <div
                    className="modal fade"
                    tabIndex="-1"
                    id="modalPreviewDefaultModal"
                    style={{ zIndex: "9999" }}
                  >
                    <div
                      className="modal-dialog modal-xl modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <div
                          className="modal-header"
                          style={{ borderBottom: "1px solid #e5e9f2" }}
                        >
                          <h5
                            className="modal-title"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "700",
                              fontSize: "1.25rem",
                              color: "#364a63",
                            }}
                          >
                            Preview Notification Email
                          </h5>
                          <a
                            style={{ cursor: "pointer" }}
                            className="close"
                            onClick={() => this.closePreviewModal()}
                          >
                            <em className="icon ni ni-cross"></em>
                          </a>
                        </div>
                        <div
                          className="modal-body"
                          style={{ padding: "1.5rem" }}
                        >
                          <div className="nk-block">
                            <div className="card card-bordered">
                              <div className="card-inner">
                                <div
                                  className="email-preview"
                                  style={{
                                    maxHeight: "60vh",
                                    overflow: "auto",
                                    padding: "1rem",
                                    backgroundColor: "#f5f6fa",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {this.state.isEditorReady ? (
                                    <div
                                      className="email-preview-content"
                                      style={{
                                        fontFamily: "'Roboto', sans-serif",
                                        fontSize: "14px",
                                        lineHeight: "1.65",
                                        pointerEvents: "none",
                                        userSelect: "none",
                                      }}
                                      dangerouslySetInnerHTML={{
                                        __html: this.state.email_template,
                                      }}
                                    />
                                  ) : (
                                    tableLoader()
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="modal-footer"
                          style={{
                            borderTop: "1px solid #e5e9f2",
                            padding: "1rem 1.5rem",
                          }}
                        >
                          <button
                            onClick={() => this.closePreviewModal()}
                            className="btn btn-primary"
                            style={{
                              fontFamily: "'DM Sans', sans-serif",
                              fontWeight: "500",
                            }}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* PREVIEW DEFAULT MODAL  */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Addagent);
